// extracted by mini-css-extract-plugin
export var hero = "blog-post-module--hero--op63j";
export var title = "blog-post-module--title--9dCoJ";